import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const SalidasDB = async ({
    numDoc,
    tipDoc,
    date,
    tipoInOut,
    rut,
    entidad,
    correo,
    patente,

    cab_id,
    eq_id,

    familia,
    tipo,
    marca,
    modelo,
    serie,
    rfid,

    tipMov,

    // Tipo de atención contractual
    tipo_atencion,

    observacion,
    historial,
    confirmado,

    // CAMPOS ST
    rut_st,
    nombre_st,
    destino_st_tipo,

    contrato_mantencion,
    tipo_cubierto_contrato,

    genera_ingreso_st,
    ingreso_st_generado,

    id_ingreso_st,
    folio_ingreso_st,

    id_mantencion,

    genera_certificado,
    reset_mantencion,

    userAdd,
    userMod,
    fechaAdd,
    fechaMod,
    emp_id,
    estadoSalida,

}) => {

    return await addDoc(
        collection(db, 'salidas'),
        {
            numdoc: numDoc,
            tipdoc: tipDoc,

            date: date,

            tipoinout: tipoInOut,

            rut: rut,
            entidad: entidad,

            correo: correo,
            patente: patente,

            cab_id: cab_id,
            eq_id: eq_id,

            familia: familia,
            tipo: tipo,
            marca: marca,
            modelo: modelo,
            serie: serie,

            rfid: rfid,

            tipmov: tipMov,

            // =========================
            // TIPO DE ATENCIÓN
            // =========================

            tipo_atencion:
                tipo_atencion || "",

            observacion:
                observacion || "",

            historial: historial,

            confirmado: confirmado,

            // =========================
            // TRAZABILIDAD ST
            // =========================

            rut_st:
                rut_st || "",

            nombre_st:
                nombre_st || "",

            destino_st_tipo:
                destino_st_tipo || "",

            contrato_mantencion:
                contrato_mantencion === true,

            tipo_cubierto_contrato:
                tipo_cubierto_contrato === true,

            genera_ingreso_st:
                genera_ingreso_st === true,

            ingreso_st_generado:
                ingreso_st_generado === true,

            id_ingreso_st:
                id_ingreso_st || "",

            folio_ingreso_st:
                folio_ingreso_st || "",

            id_mantencion:
                id_mantencion || "",

            genera_certificado:
                genera_certificado === true,

            reset_mantencion:
                reset_mantencion === true,

            // =========================
            // AUDITORÍA
            // =========================

            useradd:
                userAdd,

            usermod:
                userMod,

            fechaadd:
                fechaAdd,

            fechamod:
                fechaMod,

            emp_id:
                emp_id,

            estado_destino:
                estadoSalida || "",
        }
    );
};

export default SalidasDB;